export interface IDirectoryUser {
  id: string;
  email: string;
  full_name: string;
  department: IDirectoryDepartment | null;
  job_title: string;
  devices: {
    id: number;
    name: string;
  }[];
  vpn_enabled: boolean;
  created_time: number;
  updated_time: number | null;
}

export interface IDirectoryDepartment {
  id: string;
  name: string;
  parent_id: string | null;
  created_time: number;
}

export interface IDirectoryDepartmentWithPath extends IDirectoryDepartment {
  path: string;
}

export const SYNC_DIRECTORY_WORKSPACE_SESSION_STORAGE_KEY =
  "directory_google_sync_workspace";
